export const TEXT = "text"
export const TEXTAREA = "textarea"
export const SELECT = "select"
export const FILE = "file"
export const CHECKBOX = "checkbox"